<template>
  <div class="wg-row">
    <div class="wg-row small-width-feed">
      <div class="com-anm22-app-text-xxl">
        {{ $anm22.strLang(lang, 'Statistics and Reports', 'Statistiche e report') }}
      </div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div 
        :class="['com-anm22-app-white-container', 'statistics-box', 'fdl', !pricing ? 'inactive' : '']"
        style="position:relative;"
    >
      <div class="statistics-box-img"></div>
      <div class="statistics-box-text">
        <template v-if="pricing">
          <a :href="'https://www.anm22.it/app/tasks/viewFDLHoursShort-v2V.php?idWorldProject='+ project.idWorldProject 
                  + (digitalDocs.length > 0 ? '&docv=' + digitalDocs[0].id : '')"
          >
            FDL
          </a>
          <img 
              v-if="docs.length > 0" 
              :src="$anm22.icons.getWorldIcon('logs')"
              class="com-anm22-app-img-s"
              style="position:absolute;top:25px;right:40px;cursor:pointer;"
              @click="showDocs = !showDocs"
          >
          <img 
              :src="$anm22.icons.getTasksIcon('photoCamera')"
              class="com-anm22-app-img-s"
              style="position:absolute;top:25px;right:15px;cursor:pointer;"
              @click="editFDLPhoto"
          >
        </template>
        <template v-else>
          FDL
          <span class="statisticsNoPricing">
            {{ $anm22.strLang(lang, "Set project pricing conditions", "Imposta condizioni economiche") }}
          </span>
          <img 
              v-if="docs.length > 0" 
              :src="$anm22.icons.getWorldIcon('logs')"
              class="com-anm22-app-img-s"
              style="position:absolute;top:25px;right:40px;cursor:pointer;"
              @click="showDocs = true"
          >
        </template>
      </div>
    </div>
    <div class="wg-row" v-show="showDocs">
      <div 
          v-for="(doc,i) in docs"
          :key="'doc-'+i"
          class="wg-row"
          style="justify-content:center;">
        <div :class="['com-anm22-app-white-container', 'statistics-box', doc.docsType === 'FDLHoursShort_v2' ? 'fdl' : '']">
          <template v-if="doc.docsType === 'FDLHoursShort_v2'">
            <div class="statistics-box-img" style="width:20px;height:20px;"></div>
            <div class="statistics-box-text">
              <a :href="'https://www.anm22.it/app/tasks/viewFDLHoursShort-v2V.php?idWorldProject='+project.idWorldProject+'&docv='+digitalDocs[0].id">
                {{ $anm22.strLang(lang, 'Version ', 'Versione del ') + versionString(doc) }}
              </a>
            </div>
          </template>
          <template v-else>
            <div class="statistics-box-img fdl-scan" style="width:20px;height:20px;"></div>
            <div class="statistics-box-text">
              <a :href="$anm22.getImagePath(doc.data.url)" target="_blank">
                {{ $anm22.strLang(lang, 'Scan ', 'Scansione del ') + versionString(doc) }}
              </a>
            </div>
          </template>
        </div>
      </div>
      <div class="wg-row" style="justify-content:center;">
        <div :class="['com-anm22-app-white-container', 'statistics-box', 'fdl']">
          <div class="statistics-box-img" style="width:20px;height:20px;"></div>
          <div class="statistics-box-text">
            <a :href="'https://www.anm22.it/app/tasks/viewFDLHoursShort-v2V.php?idWorldProject='+project.idWorldProject">
              {{ $anm22.strLang(lang, "Automatically generated version", "Versione auto generata") }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div 
        class="wg-row" 
        style="justify-content:center;"
        v-for="(u,i) in users"
        :key="'us-'+i">
      <div :class="['com-anm22-app-white-container', 'statistics-box', 'user-expenses']">
        <div class="statistics-box-img"></div>
        <div class="statistics-box-text">
          <a :href="'https://www.anm22.it/app/tasks/viewUserExpenseListV.php?idWorldProject='+project.idWorldProject+'&WorldOutgo_user='+u.idWorldUser">
            {{ $anm22.strLang(lang, "Expenses report", "Nota spese") }}
            <br />{{ u.name + ' ' + u.surname }}
          </a>
        </div>
      </div>
    </div>
    <template v-if="userPermission < 3">
      <div class="vertical-height-div" style="height:25px;"></div>
      <div class="wg-row small-width-feed">
        <div class="com-anm22-app-text-xxl">
          {{ $anm22.strLang(lang, "Administration", "Amministrazione") }}
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <div :class="['com-anm22-app-white-container', 'project-dashboard-box', 'statistics']">
        <div class="box-img"></div>
        <div class="box-text">
          <a :href="'https://www.anm22.it/app/tasks/projectStatisticsAdminV.php?idWorldProject='+project.idWorldProject">
            {{ $anm22.strLang(lang, "Administration", "Amministrazione") }}
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    projectId: [Number, String],
    customerManager: [Boolean]
  },
  data() {
    return {
      loading: false,
      showDocs: false,
      docs: [],
      digitalDocs: []
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      offline: state => state.offline.isOffline,
      windowWidth: state => state.windowWidth
    }),
    project() {
      return this.$store.getters["projects/get"](
        this.projectId
      );
    },
    users() {
      return this.project.users.map(u => this.$store.getters['users/get'](u));
    },
    userPermission() {
      return this.$store.getters["employments/getPermByProject"](this.project);
    },
    pricing() {
      return this.$store.getters["pricings/getByProject"](
        this.project.idWorldProject
      );
    }
  },
  methods: {
    editFDLPhoto() {
      window.location.href = 'https://www.anm22.it/app/tasks/editFDLAddPhotoV.php?idWorldProject=' + this.project.idWorldProject;
    },
    versionString(doc) {
      return this.$moment.unix(doc.date).format('DD-MM-YYYY HH:mm') + ' UTC';
    }
  },
  created() {
    this.$http
      .get("link/statistics?idProject=" + this.projectId)
      .then(response => {
        this.$store.dispatch('pricings/update', {
          vlf: this.$vlf('pricings'), objs: [response.data.pricing]
        })
        .then(() => {
          this.docs = response.data.docs;
          this.digitalDocs = response.data.digitalDocs;
          this.loading = false;
          this.$Progress.finish();
        });
      })
      .catch(e => console.log(e));
  }
}
</script>

<style lang="scss" scoped>

</style>
